import { DecodeStringType } from './decode-string.models';

function decodeString({ text, from, to }: DecodeStringType): string {
  return Buffer.from(text, from).toString(to);
}

export default decodeString;
